import { grayWarm, successGreenDark, successGreenAlt, orangeRestricted, criticalRed } from '../../themes/colors';

export const ratingVariants = <const> [
	'neutral',
	'success',
	'info',
	'primaryDark',
	'warning',
	'danger',
];

export type RatingVariant = typeof ratingVariants[number];

export const RatingVariantCssDefinition = {
	neutral: {
		color: grayWarm,
		borderColor: grayWarm,
		backgroundColor: 'rgba(154, 159, 159, 0.1)',
	},
	primaryDark: {
		color: successGreenDark,
		borderColor: successGreenDark,
		backgroundColor: 'rgba(13, 124, 48, 0.1)',
	},
	info: {
		color: grayWarm,
		borderColor: grayWarm,
		backgroundColor: 'rgba(154, 159, 159, 0.1)',
	},
	success: {
		color: successGreenAlt,
		borderColor: successGreenAlt,
		backgroundColor: 'rgba(18, 163, 77, 0.1)',
	},
	warning: {
		color: orangeRestricted,
		borderColor: orangeRestricted,
		backgroundColor: 'rgba(247, 145, 22, 0.1)',
	},
	danger: {
		color: criticalRed,
		borderColor: criticalRed,
		backgroundColor: 'rgba(220, 38, 38, 0.1)',
	},
};
